import { fetchCarShareCardFile } from '../../infrastructure/content/shareCardFile';
import { resolveCanonicalOrigin } from '../i18n/localeDocumentMetadata';
import { SHARE_RESULTS, shareImage } from './shareImage';

/**
 * Share one car as a card — the picture built for a feed rather than for a
 * filing cabinet.
 *
 * The second caller of `shareImage.js` beside `shareApp.js`, and thin for the
 * same reason: the ladder — file, link, clipboard — belongs to neither of them.
 *
 * What is particular here is the ADDRESS. `window.location.href` would be the
 * obvious answer and it is wrong twice over: on a Firebase mirror or a preview
 * channel it is an address that is not the product's, and it carries the
 * garage's filter query, which is the sender's shelf rather than anything about
 * this car. The canonical address is also the one the social document is served
 * at and the one `<link rel="canonical">` publishes, so the three stay one fact.
 */

export { SHARE_RESULTS };

export function carShareUrl(localeCode, carId, locationObject) {
    return `${resolveCanonicalOrigin(locationObject)}/${localeCode}/cars/${carId}`;
}

/**
 * `shape` is a parameter rather than a second function, because the shape is the
 * ONLY thing that differs between the picture rows a chooser offers. A
 * `shareCarPostCard` beside this one would be the same five lines with one word
 * changed, which is the repo contract's "second way of doing an established
 * thing".
 */
export async function shareCar(
    { carId, name, languageCode, localeCode, title, text, shape = 'portrait' },
    {
        nav = typeof navigator === 'undefined' ? null : navigator,
        loadFile = fetchCarShareCardFile,
        locationObject = typeof window === 'undefined' ? null : window.location,
    } = {},
) {
    return shareImage(
        { title, text, url: carShareUrl(localeCode, carId, locationObject) },
        () => loadFile({ carId, name, languageCode, shape }),
        nav,
    );
}
